/* eslint-disable @typescript-eslint/no-explicit-any */
export interface CustomWindow extends Window {
  dataLayer: any;
  optimizely: any;
  Trustpilot: any;
  MSStream: any;
}
